module.exports = __webpack_public_path__ + "img/UTHYRU-3.e65d52ef.jpg";